<div
  id="lead-source-modal"
  role="dialog"
  aria-labelledby="leadSourceModalLabel"
>
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="leadSourceModalLabel">
          {{ (isNew ? 'kanban.productFormModal.titleAdd' : 'kanban.productFormModal.titleEdit') | translate }}
        </h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-hidden="true"
          (click)="close()"
        ></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">
                {{ 'kanban.productFormModal.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="name"
                [placeholder]="'kanban.productFormModal.namePlaceholder' | translate"
              />
              <field-error-component
                [field]="'name'"
                [label]="'kanban.productFormModal.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">{{ 'kanban.productFormModal.description' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="description"
                [placeholder]="'kanban.productFormModal.descriptionPlaceholder' | translate"
              />
            </div>
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">{{ 'kanban.productFormModal.code' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="code"
                [placeholder]="'kanban.productFormModal.codePlaceholder' | translate"
              />
              <field-error-component
                [field]="'code'"
                [label]="'kanban.productFormModal.code' | translate"
                [formGroup]="formGroup"
              />
              @if (formGroup.get('code')?.hasError('codeExists') && (formGroup.get('code')?.dirty || formGroup.get('code')?.touched)) {
                <span class="form-text small text-danger">
                  {{ 'kanban.productFormModal.codeExists' | translate }}
                </span>
              }
            </div>
            <div class="col-xs-12 col-lg-6 mb-3">
              <label class="form-label">
                {{ 'kanban.productFormModal.price' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                formControlName="price"
                [placeholder]="'kanban.productFormModal.pricePlaceholder' | translate"
                mask="separator.2"
                thousandSeparator="."
                decimalMarker=","
                prefix="R$ "
                [typeFromDecimals]="true"
                [leadZero]="true"
                [outputTransformFn]="moneyMaskOutput"
              />
              <field-error-component
                [field]="'price'"
                [label]="'kanban.productFormModal.price' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'kanban.productFormModal.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary"
          (click)="save()"
          [disabled]="loading || formGroup.invalid"
        >
          @if (loading) {
          <mat-spinner [diameter]="25" mode="indeterminate" class="px-3" />
          } @else {
          {{ (isNew ? 'kanban.productFormModal.save' : 'kanban.productFormModal.update') | translate }}
          }
        </button>
      </div>
    </div>
  </div>
</div>
